<template>
    <nav :class="['navbar', {'scrolled': isScrolled}]">
      <div class="container">
        <div class="navbar-brand">
        </div>
        <div class="navbar-toggle" @click="toggleMenu">
          <span></span>
          <span></span>
          <span></span>
        </div>
        <div class="navbar-menu" :class="{'active': isMenuActive}">
          <ul class="navbar-links">
            <li><a href="#home" @click="closeMenu">首頁</a></li>
            <li><a href="#our-story" @click="closeMenu">我們的故事</a></li>
            <li><a href="#gallery" @click="closeMenu">相簿</a></li>
            <li><a href="#event" @click="closeMenu">婚禮資訊</a></li>
            <li><a href="#rsvp" @click="closeMenu">RSVP</a></li>
            <li><a href="#gifts" @click="closeMenu">禮物</a></li>
          </ul>
        </div>
      </div>
    </nav>
  </template>

<script>
// ✅ 匯入你外部拆分的邏輯模組
import NavbarLogic from "@/assets/js/navbar.js";

export default {
  name: "NavbarLogic",
  mixins: [NavbarLogic], // ✅ 使用 mixin 混入邏輯
};
</script>

<!-- ✅ 匯入你的樣式檔 -->
<style src="@/assets/css/navbar.css" scoped></style>